import { render, staticRenderFns } from "./CRAddressSelector.vue?vue&type=template&id=be8c32b2&scoped=true"
import script from "./CRAddressSelector.vue?vue&type=script&lang=js"
export * from "./CRAddressSelector.vue?vue&type=script&lang=js"
import style0 from "./CRAddressSelector.vue?vue&type=style&index=0&id=be8c32b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c32b2",
  null
  
)

export default component.exports